<app-portal></app-portal>

<div class="div-main">

    <div class="div-body">

        <p class="p-titulo margin-bot0">SEJA BEM-VINDO À PLATAFORMA DE AFILIADOS!</p>
        <p class="p-subtitulo">Aqui você controla toda sua estratégia de venda!</p>

        <p>É permitido: <br>
            - É permitido postar e repostar as comunicações que publicamos em nossas redes oficiais.<br>
            - É permitido compartilhar nossos posts via Facebook, WhatsApp, Instagram, Telegram e E-mail.<br>
        </p>

        <p>Não é permitido: <br>
            - Não é permitido alterar as artes, imagem ou qualquer material disponibilizado para download.<br>
            - Não é permitido criar ou utilizar materiais não oficiais. <br>
            - Não é permitido utilizar o conteúdo em sites duvidosos e maliciosos.  <br>
            - Não é permitido prestar qualquer informação referente a funcionalidade dos cursos, certificação, validação e tempo de conclusão. <br>
        </p>

        <p class="p-txtgrande">DOWNLOADS</p>

        <div class="div-download">
            <div class="div-img-download">
                <img class="img-download" src="../../../../../assets/img-download/teste.png" alt="img_download">
                <a href="#" download="teste.png">
                    <button mat-raised-button color="primary"> Download </button>
                </a>
            </div>

            <div class="div-img-download">
                <img class="img-download" src="../../../../../assets/img-download/teste.png" alt="img_download">
                <a href="#" download="teste.png">
                    <button mat-raised-button color="primary"> Download </button>
                </a>
            </div>

            <div class="div-img-download">
                <img class="img-download" src="../../../../../assets/img-download/teste.png" alt="img_download">
                <a href="#" download="teste.png">
                    <button mat-raised-button color="primary"> Download </button>
                </a>
            </div>
        </div>

        <p class="p-selecione">Selecione uma das imagens acima para baixar</p>

    </div>

</div>

<app-compartilhe></app-compartilhe>